import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = React.useState(false);

  const isAuthed = user && typeof user === "object";

  const links = [
    { to: "/", label: "Home" },
    { to: "/curriculum", label: "Curriculum" },
    { to: "/assessment", label: "Assessment" },
    { to: "/speaker", label: "Speaker" },
    { to: "/pricing", label: "Pricing" },
  ];

  return (
    <header className="glass-header sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-display text-2xl text-[#2D2A26] font-semibold tracking-tight">Divine Alignment</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm tracking-wide transition-colors ${
                loc.pathname === l.to ? "text-[#A36B5E]" : "text-[#5C5852] hover:text-[#2D2A26]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {isAuthed ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm text-[#5C5852] hover:text-[#2D2A26]">
                Dashboard
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="text-sm text-[#5F6F52]">Admin</Link>
              )}
              <button
                onClick={() => { logout(); nav("/"); }}
                data-testid="nav-logout"
                className="text-sm text-[#5C5852] hover:text-[#2D2A26]"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-[#5C5852] hover:text-[#2D2A26]">
                Log in
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="btn-primary text-sm rounded-full px-5 py-2"
              >
                Begin
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden p-2 text-[#2D2A26]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#EAE5D9] px-6 py-4 space-y-3 bg-[#FDFBF7]">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="block text-[#2D2A26] py-1"
            >
              {l.label}
            </Link>
          ))}
          {isAuthed ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)} className="block text-[#2D2A26] py-1">Dashboard</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="block text-[#5F6F52] py-1">Admin</Link>}
              <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="block text-[#2D2A26] py-1">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="block text-[#2D2A26] py-1">Log in</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="block text-[#A36B5E] py-1">Begin</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
